import {deleteTags, TagUpdateType, useUpdateTags} from "@twigsby/client-data";
import {Button, ColourSolid, Modal, ModalType} from "@twigsby/frontend-framework";
import React from "react";
import {useTranslation} from "@twigsby/frontend-framework";

interface DeleteTagModalType extends ModalType {
    selectedTags: Array<number>;
}

const DeleteTagModal = (props: DeleteTagModalType) => {
    const{ t } = useTranslation();
    const updateTags = useUpdateTags();

    const DeleteTags = () => {
        deleteTags(props.selectedTags).then(() => {
            updateTags.mutate({
                newData: props.selectedTags,
                tagIds: props.selectedTags,
                updateType: TagUpdateType.DELETE
            })

            if(props.actionedCallback) {
                props.actionedCallback();
            }

        })
    }

    return (
        <Modal title={t('settings.tags.actions.delete', { count: props.selectedTags.length })} isOpen={props.isOpen} closeCallback={() => props.closeCallback()}>
            <p>{t('messages.deleteConfirm')}</p>
            <Button title={t('actions.delete')} fullWidth={true} colour={ColourSolid.Primary} onClick={() => DeleteTags()}  />
        </Modal>
    )
}

export default DeleteTagModal
